<template>
	<header>
		<div class="stripe">
			<p>
				{{ $t('home_commitment') }}
				<router-link :to="{name:'CommitmentFB'}">En savoir plus</router-link>
			</p>
		</div>
		<div class="topbar">
			<div class="topbar__burger">
				<input type="checkbox" id="burger" name="burger" v-model="burgerMenu">
				<label for="burger">
					<span></span>
				</label>
				<div class="burger__wrapper">
					<div class="burger__wrapper__scroller">
						<div class="menu-item delivery">
							<a  aria-label="En apprendre plus" class="inactive-link" @click="selectLocation">
								<img alt="" src="@/assets/header/delivery.png">
								<span
									v-if="!getLocation || getLocation.city===null || getLocation.city==='null'">
								{{ $t('find_out_more') }}
							</span>
								<span v-else>
								<span class="small">{{ $t('deliver_at') }}</span>
								{{ getLocation.city }}
							</span>
							</a>
						</div>
						<nav class="burger__list">
							<ul class="burger__list-products">
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'huître-en-ligne'}}" @click.native="closeBurger">
										{{ $t('oyster_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'crustacé-en-ligne'}}" @click.native="closeBurger">
										{{ $t('crustacean_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'coquillage-en-ligne'}}" @click.native="closeBurger">
										{{ $t('shellfish_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'epicerie-en-ligne'}}" @click.native="closeBurger">
										{{ $t('grocery_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'vin-en-ligne'}}" @click.native="closeBurger">
										{{ $t('cellar_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'coffret'}}" @click.native="closeBurger">
										{{ $t('boxes_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Shop', params: {category: 'accessoires'}}" @click.native="closeBurger">
										{{ $t('accessory_categ') }}
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name:'Gift'}" @click.native="closeBurger">{{$t('gift')}}
									</router-link>
								</li>
							</ul>
							<ul class="burger__list-about">
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'HowItWork'}" @click.native="closeBurger">
											Comment ça marche ?
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'WhoAreWe'}" @click.native="closeBurger">
											Qui sommes-nous ?
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'CommitmentFB'}" @click.native="closeBurger">
											Nos engagements
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'PointsOfSales'}" @click.native="closeBurger">
											Nos points de vente
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'Services'}" @click.native="closeBurger">
											Nos prestations
									</router-link>
								</li>
								<li>
									<router-link class="inactive-link" exact-active-class="active-link"
										:to="{name: 'ContactUs'}" @click.native="closeBurger">
											Nous contacter
									</router-link>
								</li>
							</ul>
							<ul class="burger__list-account login">
								<template v-if="getIsAuthenticated">
									<li>
										<router-link class="inactive-link" exact-active-class="active-link"
										             :to="{name:'Account'}"
										             @click.native="closeBurger">{{ $t('my_account') }}
										</router-link>
									</li>
									<li>
										<router-link class="inactive-link" exact-active-class="active-link"
										             :to="{name:'Address'}"
										             @click.native="closeBurger">{{ $t('my_address') }}
										</router-link>
									</li>
									<li>
										<router-link class="inactive-link" exact-active-class="active-link"
										             :to="{name: 'Invoice'}"
										             @click.native="closeBurger">{{ $t('my_orders') }}
										</router-link>
									</li>
									<li>
										<router-link class="inactive-link" exact-active-class="active-link"
										             :to="{name:'Help'}"
										             @click.native="closeBurger">{{ $t('contact') }}
										</router-link>
									</li>
									<li>
										<router-link class="inactive-link" exact-active-class="active-link"
										             :to="{name:'logout'}"
										             @click.native="closeBurger">{{ $t('logout') }}
										</router-link>
									</li>
								</template>

								<li class="menu-item not-connected" v-else>
									<router-link class="dropdown-item" :to="{name:'Registration'}"
									             @click.native="closeBurger">
										<img src="@/assets/header/account.png" alt="account-logo">
										<span>{{ $t('connection') }}</span>
									</router-link>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
			<div class="topbar__search">
<!--				<form action="#" method="get">-->
<!--					<button type="submit">-->
<!--						<font-awesome-icon icon="fa-solid fa-magnifying-glass"/>-->
<!--					</button>-->
<!--					<input type="text" placeholder="Qu'est-ce qui vous ferait plaisir ?">-->
<!--				</form>-->
			</div>
			<div class="topbar__logo">
				<router-link class="inactive-link" exact-active-class="active-link"
				             :to="{name: 'Home'}">
					<h1>La Famille Boutrais</h1>
				</router-link>
			</div>
			<div class="topbar__buttons">
				<div class="menu-item delivery">
					<a aria-label="Livraison" class="inactive-link" @click="selectLocation">
						<img alt="" src="@/assets/header/delivery.png">
						<span v-if="!getLocation || getLocation.city===null || getLocation.city==='null'">
                            {{ $t('delivery') }}
						</span>
						<span v-else>
							<span class="small">Livré à</span>
							{{ getLocation.city }}
						</span>
					</a>
				</div>
				<div class="menu-item login" v-if="getIsAuthenticated">
					<details aria-label="My account menu" tabindex="0">
						<summary>
							<img src="@/assets/header/account.png" alt="my-profile">
							<span>{{ $t('my_profile') }}</span>
						</summary>
						<div class="dropdown">
							<router-link class="dropdown-item" :to="{name:'Account'}">
								{{ $t('my_account') }}
							</router-link>
							<router-link class="dropdown-item" :to="{name:'Address'}">
								{{ $t('my_address') }}
							</router-link>
							<router-link class="dropdown-item" :to="{name:'Invoice'}">
								{{ $t('my_orders') }}
							</router-link>
							<router-link class="dropdown-item" :to="{name:'Help'}">
								{{ $t('contact') }}
							</router-link>
							<router-link class="dropdown-item" :to="{name:'logout'}">
								{{ $t('logout') }}
							</router-link>
						</div>
					</details>
				</div>

				<div class="menu-item login" v-else>
					<router-link class="dropdown-item" :to="{name:'Registration'}">
						<img alt="" src="@/assets/header/account.png">
						<span>{{ $t('connection') }}</span>
					</router-link>
				</div>
				<div class="menu-item cart" @mouseover="showCart = true" @mouseleave="showCart = false">
					<router-link class="inactive-link" :to="{name:'Cart'}" @click.native="showCart = false">
						<svg width="60" height="50" viewBox="0 0 60 50" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M56.7352 22.01C56.3329 24.3847 55.9346 26.6163 55.5826 28.8557C54.8632 33.4079 54.1439 37.9639 53.4825 42.5239C53.2234 44.2991 53.0764 46.0975 52.972 47.8883C52.8753 49.5243 52.5156 50.0038 50.7829 50C47.0468 49.9884 43.3145 49.8917 39.5784 49.8453C36.2329 49.8027 32.8874 49.8453 29.5419 49.7331C25.9411 49.6132 22.3443 49.2419 18.7474 49.1916C15.487 49.1452 12.2227 49.4353 8.96228 49.4662C8.2313 49.474 7.49259 49.0176 6.81575 48.7933C5.86818 39.8397 4.93609 31.0215 4.01946 22.3503C3.74873 22.1415 3.65977 22.0139 3.54374 21.9868C1.0646 21.4376 1.07233 21.4414 0.89442 18.8849C0.782259 17.2954 0.643025 15.7096 0.492188 13.8454C1.14968 13.8416 1.79558 13.8377 2.4376 13.83C7.38042 13.7487 12.3232 13.6675 17.2699 13.5747C17.7998 13.5631 18.3335 13.4355 18.8634 13.4625C20.395 13.5438 21.1956 12.7084 21.9768 11.4746C24.0924 8.15229 26.3666 4.93056 28.5866 1.67016C28.8496 1.28339 29.1281 0.900501 29.4568 0.571753C30.2265 -0.205639 30.7602 -0.217243 31.4138 0.703251C32.6051 2.39727 33.6919 4.16477 34.8367 5.88973C36.3876 8.22578 37.9617 10.5502 39.5126 12.8863C40 13.6211 40.6381 13.9151 41.5393 13.888C46.8147 13.7294 52.0901 13.6443 57.3617 13.4741C59.1834 13.4161 59.9337 14.0311 59.9337 15.9107C59.9337 17.3108 59.9027 18.7148 59.8757 20.1149C59.8486 21.3912 59.7055 21.5536 58.3905 21.7702C57.9187 21.8553 57.4584 21.9094 56.7352 22.01ZM9.53082 47.3468C11.3138 47.3623 13.1006 47.3313 14.8836 47.4009C20.5652 47.6291 26.239 47.9927 31.9244 48.1203C37.2772 48.2402 42.6338 48.1319 47.9866 48.1242C48.9032 48.1242 49.816 48.1087 50.9608 48.101C52.1482 39.2364 54.0124 30.7353 54.7549 21.8321C49.2436 21.8785 44.0494 21.9906 38.8551 21.9481C33.6377 21.9056 28.4242 21.6774 23.2106 21.5884C18.0087 21.4995 12.8106 21.4879 7.60861 21.4414C10.138 22.0487 12.7139 21.3796 15.251 22.0023C14.8952 22.1956 14.5317 22.273 14.1642 22.3117C11.7702 22.5515 9.37225 22.768 6.98206 23.0426C6.69972 23.0736 6.45606 23.4255 6.19693 23.6267C6.23561 23.7427 6.27428 23.8587 6.31296 23.9747C7.84841 23.9631 9.38772 23.9477 11.3409 23.9322C9.51149 25.0461 7.5506 24.23 6.29749 25.9047C8.0766 25.8892 9.85184 25.8737 11.6309 25.8583C11.6387 26.0168 11.6503 26.1754 11.658 26.334C10.9618 26.4423 10.2618 26.5351 9.5695 26.6666C8.78824 26.8136 8.01085 26.9915 7.23345 27.1694C6.38258 27.3628 6.22401 27.912 6.45219 28.6623C7.74785 29.4668 9.32971 28.2678 10.7994 29.3314C9.26782 29.6137 7.98377 29.8497 6.50634 30.1204C6.64171 30.9326 6.75774 31.621 6.85056 32.1857C8.25064 32.8857 9.7242 31.9885 11.2016 32.9206C9.56563 33.2029 8.2429 33.4272 6.80028 33.6747C7.02074 34.8041 7.18318 35.6395 7.34948 36.5097C8.42855 36.6064 9.38385 36.6954 10.3353 36.7843C10.3392 36.8617 10.343 36.9351 10.3469 37.0125C9.34131 37.2639 8.33573 37.5153 7.23732 37.7899C7.4191 38.7104 7.58154 39.5381 7.75172 40.416C9.27943 40.5398 10.637 40.6519 11.9906 40.7641C11.9906 40.8685 11.9906 40.9768 11.9868 41.0812C10.637 41.2669 9.29103 41.4525 7.77492 41.6614C7.84841 42.4349 7.91029 43.1195 7.96057 43.6416C9.39932 44.4074 10.9193 43.4134 12.3581 44.5853C10.8265 44.7671 9.59657 44.9141 8.0882 45.092C8.34733 45.7959 8.53684 46.3103 8.72636 46.8247C8.99709 46.9948 9.26396 47.1727 9.53082 47.3468ZM4.71176 19.5115C4.70016 19.6585 4.69243 19.8016 4.68082 19.9485C5.40407 19.9408 6.12731 19.9369 6.85056 19.9292C9.85957 19.906 12.8724 19.8016 15.8776 19.8828C20.685 20.0066 25.4886 20.3856 30.2961 20.4165C37.3893 20.4629 44.4864 20.3276 51.5796 20.2077C53.7648 20.169 55.9462 19.9331 58.2126 19.7822C58.3132 18.27 58.3982 16.9666 58.4911 15.524C53.2427 15.5665 48.1374 15.6091 42.9626 15.6555C43.0399 15.9842 43.0825 16.1699 43.125 16.3594C43.5195 18.0998 42.6609 19.3955 40.9243 19.6855C39.3309 19.9524 38.1783 18.9584 38.0197 17.1793C37.9772 16.6727 37.954 16.166 37.9192 15.6361C32.8835 15.4582 27.9717 15.2919 23.1333 15.1256C22.9631 16.3517 22.9979 17.4539 22.6343 18.4015C22.1818 19.5811 20.8978 19.5927 19.8574 19.585C18.0396 19.5695 17.2003 18.1462 17.2699 15.4737C17.2119 15.4428 17.1539 15.3809 17.0959 15.3809C12.4161 15.435 7.73238 15.4853 3.05255 15.5781C2.85917 15.582 2.67353 15.9649 2.26356 16.4135C5.18361 16.3903 7.77492 16.3671 10.3624 16.3439C9.60431 16.7075 8.83078 16.8467 8.04952 16.9434C6.52568 17.1368 4.9941 17.2799 3.47026 17.5003C3.16858 17.5429 2.90558 17.8368 2.62325 18.0147C2.65419 18.1617 2.68126 18.3087 2.7122 18.4556C4.92062 18.4866 7.12903 18.5175 9.33744 18.5446C9.34131 18.6877 9.34518 18.8308 9.34904 18.9739C7.802 19.1557 6.25495 19.3336 4.71176 19.5115ZM22.7194 13.0294C22.8161 13.1918 22.9089 13.3542 23.0056 13.5167C27.8518 13.3658 32.6979 13.9189 37.865 13.5786C35.0146 9.84244 33.278 5.76597 30.1259 2.27737C27.5307 6.0367 25.1251 9.53304 22.7194 13.0294ZM19.1573 16.576C19.5634 17.8059 20.1939 18.3357 20.8204 17.918C21.6674 17.3534 21.3193 16.6147 20.9867 15.903C20.3602 16.1351 19.838 16.3246 19.1573 16.576ZM39.6635 16.8699C40.0696 17.7788 40.3519 18.4286 41.1835 18.0573C41.4039 17.9606 41.6244 17.3418 41.5199 17.1174C41.11 16.2511 40.4602 16.808 39.6635 16.8699Z"
								fill="#f5aa34"/>
							<path
								d="M8.73023 46.8169C8.912 46.5501 9.07058 46.0705 9.27556 46.055C10.2386 45.966 11.2132 46.0009 12.2614 46.2677C11.3563 46.6313 10.4474 46.9948 9.53469 47.3545C9.26396 47.1727 8.99709 46.9948 8.73023 46.8169Z"
								fill="#f5aa34"/>
							<path
								d="M21.0409 43.8118C21.0254 41.9592 21.0022 40.3038 20.9983 38.6485C20.9906 34.7731 20.9829 30.8978 20.9983 27.0263C21.0022 26.2257 21.0911 25.429 21.1608 24.6284C21.2381 23.7388 21.6636 23.2902 22.8084 23.557C22.82 24.9378 22.8432 26.3069 22.8393 27.6799C22.8238 32.4835 22.7968 37.2832 22.7774 42.0868C22.7697 43.3399 22.7774 43.3399 21.0409 43.8118Z"
								fill="#f5aa34"/>
							<path
								d="M39.4894 24.1643C39.4972 25.3091 39.5668 26.3495 39.5049 27.386C39.2303 32.178 38.9248 36.97 38.627 41.7581C38.5999 42.2183 38.5883 42.6979 38.4529 43.1311C38.2673 43.7383 37.9153 44.2218 36.9987 43.9471C36.9368 43.5643 36.786 43.1272 36.813 42.7018C37.1147 37.9833 37.4512 33.2648 37.7606 28.5424C37.8264 27.5446 37.7993 26.5428 37.8496 25.545C37.8844 24.7908 37.9849 24.0444 39.4894 24.1643Z"
								fill="#f5aa34"/>
							<path
								d="M30.8608 23.7891C30.8724 25.2085 30.911 26.4539 30.8878 27.6954C30.8066 32.0271 30.7061 36.3589 30.621 40.6867C30.6094 41.2862 30.6829 41.8896 30.6635 42.4891C30.6248 43.6223 30.6094 43.6223 29.0507 43.835C29.0275 41.2127 28.954 38.5866 28.9966 35.9644C29.0546 32.4951 29.2325 29.0297 29.3098 25.5605C29.3292 24.6554 29.5226 24.0057 30.8608 23.7891Z"
								fill="#f5aa34"/>
							<path
								d="M12.0912 24.1875C12.6829 24.1178 13.1432 24.0637 13.8703 23.9747C14.2106 26.1329 14.6477 28.2678 14.8643 30.4259C15.1659 33.4117 15.2858 36.413 15.5218 39.4027C15.5837 40.1956 15.7229 40.9962 15.9472 41.7581C16.2566 42.8062 15.7809 43.2355 14.7947 43.4714C13.9786 42.1526 14.0405 40.6635 13.8819 39.2325C13.4101 34.9936 12.9691 30.7508 12.4973 26.5119C12.4083 25.7422 12.2304 24.9803 12.0912 24.1875Z"
								fill="#f5aa34"/>
							<path
								d="M48.8955 23.8664C48.8994 24.2958 48.9612 24.7367 48.8994 25.1582C48.0485 30.8243 47.1744 36.4865 46.3197 42.1487C46.0489 43.9549 46.0489 43.982 44.5212 44.2798C44.4593 43.8969 44.2969 43.5024 44.3549 43.1465C45.2483 37.6275 46.1688 32.1084 47.0932 26.5931C47.2015 25.9356 47.302 25.2549 47.565 24.6554C47.7391 24.2609 48.1916 23.9902 48.5203 23.6615C48.6441 23.7311 48.7679 23.7968 48.8955 23.8664Z"
								fill="#f5aa34"/>
						</svg>
						<div class="badge">
							<span>{{ getCartLength }}</span>
						</div>
					</router-link>
					<div class="shopping-cart" :class="{'active': showCart}" id="shopping-cart">
						<div class="shopping-cart-header">
							<div class="shopping-cart-count">
								<svg width="60" height="50" viewBox="0 0 60 50" fill="none"
								     xmlns="http://www.w3.org/2000/svg">
									<path
										d="M56.7352 22.01C56.3329 24.3847 55.9346 26.6163 55.5826 28.8557C54.8632 33.4079 54.1439 37.9639 53.4825 42.5239C53.2234 44.2991 53.0764 46.0975 52.972 47.8883C52.8753 49.5243 52.5156 50.0038 50.7829 50C47.0468 49.9884 43.3145 49.8917 39.5784 49.8453C36.2329 49.8027 32.8874 49.8453 29.5419 49.7331C25.9411 49.6132 22.3443 49.2419 18.7474 49.1916C15.487 49.1452 12.2227 49.4353 8.96228 49.4662C8.2313 49.474 7.49259 49.0176 6.81575 48.7933C5.86818 39.8397 4.93609 31.0215 4.01946 22.3503C3.74873 22.1415 3.65977 22.0139 3.54374 21.9868C1.0646 21.4376 1.07233 21.4414 0.89442 18.8849C0.782259 17.2954 0.643025 15.7096 0.492188 13.8454C1.14968 13.8416 1.79558 13.8377 2.4376 13.83C7.38042 13.7487 12.3232 13.6675 17.2699 13.5747C17.7998 13.5631 18.3335 13.4355 18.8634 13.4625C20.395 13.5438 21.1956 12.7084 21.9768 11.4746C24.0924 8.15229 26.3666 4.93056 28.5866 1.67016C28.8496 1.28339 29.1281 0.900501 29.4568 0.571753C30.2265 -0.205639 30.7602 -0.217243 31.4138 0.703251C32.6051 2.39727 33.6919 4.16477 34.8367 5.88973C36.3876 8.22578 37.9617 10.5502 39.5126 12.8863C40 13.6211 40.6381 13.9151 41.5393 13.888C46.8147 13.7294 52.0901 13.6443 57.3617 13.4741C59.1834 13.4161 59.9337 14.0311 59.9337 15.9107C59.9337 17.3108 59.9027 18.7148 59.8757 20.1149C59.8486 21.3912 59.7055 21.5536 58.3905 21.7702C57.9187 21.8553 57.4584 21.9094 56.7352 22.01ZM9.53082 47.3468C11.3138 47.3623 13.1006 47.3313 14.8836 47.4009C20.5652 47.6291 26.239 47.9927 31.9244 48.1203C37.2772 48.2402 42.6338 48.1319 47.9866 48.1242C48.9032 48.1242 49.816 48.1087 50.9608 48.101C52.1482 39.2364 54.0124 30.7353 54.7549 21.8321C49.2436 21.8785 44.0494 21.9906 38.8551 21.9481C33.6377 21.9056 28.4242 21.6774 23.2106 21.5884C18.0087 21.4995 12.8106 21.4879 7.60861 21.4414C10.138 22.0487 12.7139 21.3796 15.251 22.0023C14.8952 22.1956 14.5317 22.273 14.1642 22.3117C11.7702 22.5515 9.37225 22.768 6.98206 23.0426C6.69972 23.0736 6.45606 23.4255 6.19693 23.6267C6.23561 23.7427 6.27428 23.8587 6.31296 23.9747C7.84841 23.9631 9.38772 23.9477 11.3409 23.9322C9.51149 25.0461 7.5506 24.23 6.29749 25.9047C8.0766 25.8892 9.85184 25.8737 11.6309 25.8583C11.6387 26.0168 11.6503 26.1754 11.658 26.334C10.9618 26.4423 10.2618 26.5351 9.5695 26.6666C8.78824 26.8136 8.01085 26.9915 7.23345 27.1694C6.38258 27.3628 6.22401 27.912 6.45219 28.6623C7.74785 29.4668 9.32971 28.2678 10.7994 29.3314C9.26782 29.6137 7.98377 29.8497 6.50634 30.1204C6.64171 30.9326 6.75774 31.621 6.85056 32.1857C8.25064 32.8857 9.7242 31.9885 11.2016 32.9206C9.56563 33.2029 8.2429 33.4272 6.80028 33.6747C7.02074 34.8041 7.18318 35.6395 7.34948 36.5097C8.42855 36.6064 9.38385 36.6954 10.3353 36.7843C10.3392 36.8617 10.343 36.9351 10.3469 37.0125C9.34131 37.2639 8.33573 37.5153 7.23732 37.7899C7.4191 38.7104 7.58154 39.5381 7.75172 40.416C9.27943 40.5398 10.637 40.6519 11.9906 40.7641C11.9906 40.8685 11.9906 40.9768 11.9868 41.0812C10.637 41.2669 9.29103 41.4525 7.77492 41.6614C7.84841 42.4349 7.91029 43.1195 7.96057 43.6416C9.39932 44.4074 10.9193 43.4134 12.3581 44.5853C10.8265 44.7671 9.59657 44.9141 8.0882 45.092C8.34733 45.7959 8.53684 46.3103 8.72636 46.8247C8.99709 46.9948 9.26396 47.1727 9.53082 47.3468ZM4.71176 19.5115C4.70016 19.6585 4.69243 19.8016 4.68082 19.9485C5.40407 19.9408 6.12731 19.9369 6.85056 19.9292C9.85957 19.906 12.8724 19.8016 15.8776 19.8828C20.685 20.0066 25.4886 20.3856 30.2961 20.4165C37.3893 20.4629 44.4864 20.3276 51.5796 20.2077C53.7648 20.169 55.9462 19.9331 58.2126 19.7822C58.3132 18.27 58.3982 16.9666 58.4911 15.524C53.2427 15.5665 48.1374 15.6091 42.9626 15.6555C43.0399 15.9842 43.0825 16.1699 43.125 16.3594C43.5195 18.0998 42.6609 19.3955 40.9243 19.6855C39.3309 19.9524 38.1783 18.9584 38.0197 17.1793C37.9772 16.6727 37.954 16.166 37.9192 15.6361C32.8835 15.4582 27.9717 15.2919 23.1333 15.1256C22.9631 16.3517 22.9979 17.4539 22.6343 18.4015C22.1818 19.5811 20.8978 19.5927 19.8574 19.585C18.0396 19.5695 17.2003 18.1462 17.2699 15.4737C17.2119 15.4428 17.1539 15.3809 17.0959 15.3809C12.4161 15.435 7.73238 15.4853 3.05255 15.5781C2.85917 15.582 2.67353 15.9649 2.26356 16.4135C5.18361 16.3903 7.77492 16.3671 10.3624 16.3439C9.60431 16.7075 8.83078 16.8467 8.04952 16.9434C6.52568 17.1368 4.9941 17.2799 3.47026 17.5003C3.16858 17.5429 2.90558 17.8368 2.62325 18.0147C2.65419 18.1617 2.68126 18.3087 2.7122 18.4556C4.92062 18.4866 7.12903 18.5175 9.33744 18.5446C9.34131 18.6877 9.34518 18.8308 9.34904 18.9739C7.802 19.1557 6.25495 19.3336 4.71176 19.5115ZM22.7194 13.0294C22.8161 13.1918 22.9089 13.3542 23.0056 13.5167C27.8518 13.3658 32.6979 13.9189 37.865 13.5786C35.0146 9.84244 33.278 5.76597 30.1259 2.27737C27.5307 6.0367 25.1251 9.53304 22.7194 13.0294ZM19.1573 16.576C19.5634 17.8059 20.1939 18.3357 20.8204 17.918C21.6674 17.3534 21.3193 16.6147 20.9867 15.903C20.3602 16.1351 19.838 16.3246 19.1573 16.576ZM39.6635 16.8699C40.0696 17.7788 40.3519 18.4286 41.1835 18.0573C41.4039 17.9606 41.6244 17.3418 41.5199 17.1174C41.11 16.2511 40.4602 16.808 39.6635 16.8699Z"
										fill="#f5aa34"/>
									<path
										d="M8.73023 46.8169C8.912 46.5501 9.07058 46.0705 9.27556 46.055C10.2386 45.966 11.2132 46.0009 12.2614 46.2677C11.3563 46.6313 10.4474 46.9948 9.53469 47.3545C9.26396 47.1727 8.99709 46.9948 8.73023 46.8169Z"
										fill="#f5aa34"/>
									<path
										d="M21.0409 43.8118C21.0254 41.9592 21.0022 40.3038 20.9983 38.6485C20.9906 34.7731 20.9829 30.8978 20.9983 27.0263C21.0022 26.2257 21.0911 25.429 21.1608 24.6284C21.2381 23.7388 21.6636 23.2902 22.8084 23.557C22.82 24.9378 22.8432 26.3069 22.8393 27.6799C22.8238 32.4835 22.7968 37.2832 22.7774 42.0868C22.7697 43.3399 22.7774 43.3399 21.0409 43.8118Z"
										fill="#f5aa34"/>
									<path
										d="M39.4894 24.1643C39.4972 25.3091 39.5668 26.3495 39.5049 27.386C39.2303 32.178 38.9248 36.97 38.627 41.7581C38.5999 42.2183 38.5883 42.6979 38.4529 43.1311C38.2673 43.7383 37.9153 44.2218 36.9987 43.9471C36.9368 43.5643 36.786 43.1272 36.813 42.7018C37.1147 37.9833 37.4512 33.2648 37.7606 28.5424C37.8264 27.5446 37.7993 26.5428 37.8496 25.545C37.8844 24.7908 37.9849 24.0444 39.4894 24.1643Z"
										fill="#f5aa34"/>
									<path
										d="M30.8608 23.7891C30.8724 25.2085 30.911 26.4539 30.8878 27.6954C30.8066 32.0271 30.7061 36.3589 30.621 40.6867C30.6094 41.2862 30.6829 41.8896 30.6635 42.4891C30.6248 43.6223 30.6094 43.6223 29.0507 43.835C29.0275 41.2127 28.954 38.5866 28.9966 35.9644C29.0546 32.4951 29.2325 29.0297 29.3098 25.5605C29.3292 24.6554 29.5226 24.0057 30.8608 23.7891Z"
										fill="#f5aa34"/>
									<path
										d="M12.0912 24.1875C12.6829 24.1178 13.1432 24.0637 13.8703 23.9747C14.2106 26.1329 14.6477 28.2678 14.8643 30.4259C15.1659 33.4117 15.2858 36.413 15.5218 39.4027C15.5837 40.1956 15.7229 40.9962 15.9472 41.7581C16.2566 42.8062 15.7809 43.2355 14.7947 43.4714C13.9786 42.1526 14.0405 40.6635 13.8819 39.2325C13.4101 34.9936 12.9691 30.7508 12.4973 26.5119C12.4083 25.7422 12.2304 24.9803 12.0912 24.1875Z"
										fill="#f5aa34"/>
									<path
										d="M48.8955 23.8664C48.8994 24.2958 48.9612 24.7367 48.8994 25.1582C48.0485 30.8243 47.1744 36.4865 46.3197 42.1487C46.0489 43.9549 46.0489 43.982 44.5212 44.2798C44.4593 43.8969 44.2969 43.5024 44.3549 43.1465C45.2483 37.6275 46.1688 32.1084 47.0932 26.5931C47.2015 25.9356 47.302 25.2549 47.565 24.6554C47.7391 24.2609 48.1916 23.9902 48.5203 23.6615C48.6441 23.7311 48.7679 23.7968 48.8955 23.8664Z"
										fill="#f5aa34"/>
								</svg>
								<div class="badge">
									<span>{{ getCartLength }}</span>
								</div>
							</div>
							<div class="shopping-cart-total">
								<span>{{ $t('total') }} : </span>
								<span class="total">{{ getTotalPrice }}€</span>
							</div>
						</div> <!--end shopping-cart-header -->

						<ul class="shopping-cart-items">
							<li v-for="(item, index) in getMyCartItems">
								<router-link :to="{name: 'Product', params: {id: item.product.product_tmpl}}">
									<div class="wrapper">
										<div class="item">
											<div class="item-title">
												<p class="item-name">{{ item.product.name }}</p>
												<p class="item-quantity"><span>x</span>{{ item.quantity }}</p>
											</div>
											<div class="item-detail">
												<p>{{ item.product.default_code }}</p>
											</div>
											<p class="item-price">{{ (item.price * item.quantity).toFixed(2) }}€</p>
										</div>
									</div>
								</router-link>
							</li>
						</ul>
						<router-link class="button full" :to="{name:'Cart'}">{{ $t('my_cart') }}</router-link>
					</div>
				</div>
			</div>
		</div>

		<div class="line">
			<div class="one"></div>
			<div class="two"></div>
			<div class="three"></div>
		</div>
		<nav class="row">
			<ul>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'huître-en-ligne'}}">{{ $t('oyster_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'crustacé-en-ligne'}}">{{ $t('crustacean_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'coquillage-en-ligne'}}">{{ $t('shellfish_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'epicerie-en-ligne'}}">{{ $t('grocery_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'vin-en-ligne'}}">{{ $t('cellar_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'coffret'}}">{{ $t('boxes_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
					             :to="{name: 'Shop', params: {category: 'accessoires'}}">{{ $t('accessory_categ') }}
					</router-link>
				</li>
				<li>
					<router-link class="inactive-link" exact-active-class="active-link"
                       :to="{name:'Gift'}">{{$t('gift')}}
					</router-link>
				</li>
				<li>
					<details>
						<summary>à Propos</summary>

						<ul class="nav-about">
							<li>
								<router-link :to="{name: 'HowItWork'}">Comment ça marche ?</router-link>
							</li>
							<li>
								<router-link :to="{name: 'WhoAreWe'}">Qui sommes-nous ?</router-link>
							</li>
							<li>
                                <router-link :to="{name: 'CommitmentFB'}">Nos engagements</router-link>
							</li>
							<li>
								<router-link :to="{name: 'PointsOfSales'}">Nos points de vente</router-link>
							</li>
							<li>
								<router-link :to="{name: 'Services'}">Nos prestations</router-link>
							</li>
							<li>
                                <router-link :to="{name: 'ContactUs'}">Nous contacter</router-link>
							</li>
						</ul>
					</details>

				</li>
			</ul>
		</nav>
		<LocationModal v-if="stateLModal"/>
	</header>
</template>

<script>

const Dropdown = () => import ("@/components/Dropdown.vue")
const LocationModal = () => import ("@/components/LocationModal.vue")
import {mapGetters, mapState} from "vuex";

export default {
	name: "NavMenu",
	components: {Dropdown, LocationModal},
	mounted() {
		// Prevent page scrolling while the burger is opened
		const burgerInput = document.querySelector('#burger')
		burgerInput.addEventListener('change', () => {
			if (this.burgerMenu === true) {
				document.querySelector('html').style.overflow = "hidden"
				document.querySelector('body').style.overflow = "hidden"
			} else {
				this.closeBurger()
			}
		})

		// Close <details> dropdown if user click elsewhere OR if target is a link ; while it's open
		document.addEventListener('click', (e) => {
			const detailsElements = [...document.querySelectorAll('details')]
			detailsElements.map(details => {
				if (!details.contains(e.target) || e.target.tagName.toLowerCase() === 'a') {
					details.removeAttribute("open")
				}
			})
		})
	},
	data() {
		return {
			burgerMenu: false,
			showCart: false,
		}
	},
	computed: {
		...mapGetters(['stateCModal']),
		...mapGetters(['stateLModal']),
		...mapState('auth', ['userId']),
		...mapGetters('auth', ['getLocation', 'getIsAuthenticated']),
		...mapGetters('cart', ['getMyCartItems', 'getTotalPrice', 'getCartLength', 'getBlockLocate']),
	},
	methods: {
		selectLocation: function () {
      if (!this.$route.meta.hideLocation){
        this.$store.dispatch('changeStateLModal', true);
        document.querySelector('html').style.overflow = "hidden"
        document.querySelector('body').style.overflow = "hidden"
      }
		},
		closeBurger: function () {
			this.burgerMenu = false;
			document.querySelector('html').style.overflow = null
			document.querySelector('body').style.overflow = null
		},
	},
}
</script>

<style lang="scss" scoped>
@use '@/scss/variables' as *;

$duration: .2s;
$distance: 8px;
$easeOutBack: cubic-bezier(0.175, 0.885, 0.320, 1.275);

header {
	@include flex(center, center, column);
	@include position(-.1px, 0, $position: sticky);
	width: 100%;
	box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
	background-color: $White;
	z-index: 20;

	.stripe {
		background-color: $Blue;
		text-align: center;
		color: $White;
		width: 100%;
		padding: 5px;
		font-weight: 300;
		letter-spacing: .5px;
		font-size: 12px;
		white-space: nowrap;
		@media screen and (min-width: 992px) {
			font-size: 14px;
		}

		a {
			color: $White;
		}
	}

	.topbar {
		@include flex(space-between, center);
		padding: 2vh 2vw;
		width: 100%;
		@media screen and (max-width: 991.99px) {
			flex-wrap: wrap;
		}

		&__burger {
			$burgerSize: 20px;
			$burgerTransition: 0.5s;
			$BurgerColor: $Blue;
			@include flex(center, center);
			flex: 0 0 10%;
			width: 30px;
			height: 30px;

			@media screen and (min-width: 992px) {
				display: none;
			}

			.burger__wrapper {
				@include position(0, 0, $position: fixed);
				height: auto;
				height: 100vh;
				height: 100dvh;
				min-width: 100vw;
				min-width: 100dvw;
				background-color: $White;
				z-index: 499;
				translate: -100%;
				transition: .7s ease-in-out;

				&:before, &:after {
					@include position(0, $right: 0);
					width: 0;
					height: 100%;
					translate: 100%;
					background-color: rgba(255, 255, 255, 0.5);
					z-index: 498;
					transition: .6s ease-in-out;
				}

				&__scroller {
					@include flex(flex-start, center, column, $gap: 5vh);
					@include position(5px, 5px);
					width: calc(100% - 10px);
					height: calc(95% - 15px);
					overflow-y: auto;
					padding: 2vh clamp(50px, 15%, 100px) 5vh;
					margin-right: 5px;
					scroll-behavior: smooth;
					@include is-firefox() {
						scrollbar-color: rgba(0, 0, 0, 0.3) $Blue;
						scrollbar-width: thin;
					}

					&::-webkit-scrollbar {
						width: 3px;
					}

					&::-webkit-scrollbar-track {
						box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
					}

					&::-webkit-scrollbar-thumb {
						background-color: $Blue;
					}
				}

				.login a, .delivery a {
					margin: 0 auto;

					img {
						@include fixed-size(50px)
					}
				}

				.menu-item a {
					@include flex(center, center, column);
					font-size: 13px;
					font-weight: 600;
					color: #8f8f8f;
					text-decoration: none;
					text-transform: uppercase;
					letter-spacing: 3px;
					transition: .2s;
					margin-left: auto;

					&:hover {
						color: $Black;

						img {
							scale: 1.3;
						}
					}

					span {
						@include flex(center, center, column);

						.small {
							font-size: 10px;
						}
					}

					img {
						max-width: 35px;
						max-height: 35px;
						height: auto;
						object-fit: contain;
						transition: .4s ease;
					}
				}

				.login .not-connected {
					margin: 0 auto;
				}

				.delivery {
					margin-bottom: auto;

					span {
						font-size: 16px;

						.small {
							font-size: 12px !important;
						}
					}
				}

				.burger__list {
					@include flex(flex-start, flex-start, column, $gap: 5vh);
					width: 100%;
					margin-bottom: auto;

					ul {
						@include flex(flex-start, flex-start, column, $gap: clamp(10px, 2vh, 20px));
						width: 100%;
						padding-top: 15px;
						position: relative;

						&:before {
							@include position(0, 0);
							width: 0;
							height: 1px;
							background-color: $Black;
							transition: .4s ease-in-out;
						}
            summary{
              color: $Black;
              font-weight: 600;
              font-size: 18px;
              position: relative;
              text-transform: uppercase;
              transition: .1s linear;
            }
						li {
							background: $t;
							overflow: hidden;
							text-align: left;

							a {
								display: flex;
								translate: 0 100%;
								color: $Black;
								font-weight: 600;
								font-size: 18px;
								position: relative;
								text-transform: uppercase;
								transition: .1s linear;

								&:after {
									@include position($bottom: 0, $left: 0);
									width: 0;
									height: 1px;
									background-color: $Black;
									transition: .1s linear;
								}

								&:hover {
									transition: .3s 0s linear !important;
									color: $Brown;
									font-weight: bold;

									&:after {
										background-color: $Brown;
										transition: .3s width linear;
										width: 0 !important;
									}
								}
							}
						}
					}
				}
			}

			// Burger Toggle
			label {
				@include flex(center, center);
				max-height: 100%;
				max-width: 100%;
				width: fit-content;
				position: relative;
				z-index: 500;
				cursor: pointer;
				padding: 2px;
				pointer-events: all;

				span {
					display: block;
					width: $burgerSize;
					height: calc($burgerSize / 7);
					background: $BurgerColor;
					position: relative;
					pointer-events: none;
					margin: calc($burgerSize / 2) auto;
					animation: CrossToMid $burgerTransition ease-in-out forwards;
					transition: .2s;

					&:before {
						@include position(calc(-#{$burgerSize} / 3), 0);
						width: $burgerSize;
						height: calc($burgerSize / 7);
						background: $BurgerColor;
						transition: .2s;
					}

					&:after {
						@include position(calc($burgerSize / 3), 0);
						width: $burgerSize;
						height: calc($burgerSize / 7);
						background: $BurgerColor;
						transition: .2s;
					}

					&:before {
						animation: CrossToUp $burgerTransition ease-in-out forwards;
					}

					&:after {
						animation: CrossToBot $burgerTransition ease-in-out forwards;
					}

				}

				@keyframes upToCross {
					0% {
						transform: none;
						top: calc(-#{$burgerSize} / 4);
					}
					50% {
						transform: none;
						top: 0;
					}
					100% {
						top: 0;
						transform: rotate(-45deg);
					}
				}
				@keyframes midToCross {
					0% {
						background: $BurgerColor;
					}
					99% {
						background: transparent;
					}
					100% {
						background: transparent;
					}
				}
				@keyframes botToCross {
					0% {
						transform: none;
						top: calc($burgerSize / 4);
					}
					50% {
						transform: none;
						top: 0;
					}
					100% {
						top: 0;
						transform: rotate(45deg);
					}
				}
				@keyframes CrossToUp {
					0% {
						top: 0;
						transform: rotate(-45deg);
					}
					50% {
						transform: none;
						top: 0;
					}
					100% {
						transform: none;
						top: calc(-#{$burgerSize} / 4);
					}
				}
				@keyframes CrossToMid {
					0% {
						background: transparent;
					}
					99% {
						background: $BurgerColor;
					}
					100% {
						background: $BurgerColor;
					}
				}
				@keyframes CrossToBot {
					0% {
						top: 0;
						transform: rotate(45deg);
					}
					50% {
						transform: none;
						top: 0;
					}
					100% {
						transform: none;
						top: calc($burgerSize / 4);

					}
				}
			}

			#burger {
				// hide checkbox
				@include position(-100vh, -100vw);
				visibility: hidden;
				opacity: 0;
				z-index: -100;

				// Burger is open
				&:checked {
					& ~ .burger__wrapper {
						translate: 0;
						pointer-events: all;

						&:before {
							width: 15%;
						}

						&:after {
							width: 60%;
						}

						.burger__list ul li {
							@for $i from 1 through 20 {
								&:nth-child(#{$i}) a {
									translate: 0 0;

									&:not(:hover) {
										transition: .4s calc(.75s + (.075s * #{$i})) ease;

										&:after {
											transition: .4s calc(1s + (.1s * #{$i})) ease;
										}
									}

									&:after {
										width: 100%;
									}
								}
							}
						}

						.burger__list ul {
							&:before {
								width: 100%;
								transition: .4s .9s ease;
							}
						}
					}

					& ~ label span {
						animation: midToCross $burgerTransition ease-in-out forwards;

						&:before {
							animation: upToCross $burgerTransition ease-in-out forwards;
						}

						&:after {
							animation: botToCross $burgerTransition ease-in-out forwards;
						}
					}
				}
			}
		}

		&__search {
			@include flex(center, center);
			flex: 0 0 30%;
			@media screen and (max-width: 991.99px) {
				display: none;
			}
			@media screen and (min-width: 992px) and (max-width: 1199.99px) {
				flex: 0 0 35%;
			}

			form {
				@include flex(space-between, center);
				width: fit-content;
				background-color: $White;
				border: 1px solid $Blue;
				align-items: center;
				border-radius: 50px;
				padding: 5px 10px;
				overflow: hidden;
				@media screen and (min-width: 992px) {
					width: 100%;
					max-width: 350px;
					gap: 5px;
				}

				button {
					appearance: none;
					background: none;
					border: none;
					width: 10%;
					min-width: 20px;
					aspect-ratio: 1;
				}

				input {
					border: none;
					@media screen and (min-width: 992px) {
						width: 100%;
					}

					&::placeholder {
						text-align: center;
						letter-spacing: 2px;
						text-transform: uppercase;
						font-size: 10px;
					}
				}

				input:focus {
					outline: none;
				}
			}
		}

		&__logo {
			flex: 0 0 calc(50% - (10vw + 15%));
			@media screen and (max-width: 991.99px) {
				flex: 0 0 auto;
			}

			a {
				display: block;

				h1 {
					color: $Black;
					font-size: 1.5vw;
					font-weight: 600;
					text-align: center;
					text-transform: uppercase;
					letter-spacing: 2px;
					white-space: nowrap;
					@media screen and (max-width: 991.99px) {
						font-size: 3.5vw;
					}
				}

				img {
					max-width: 200px;
					object-fit: contain;
				}
			}
		}

		&__buttons {
			@include flex(space-around, flex-start, $gap: 20px);
			flex: 0 0 30%;
			@media screen and (max-width: 991.99px) {
				flex: 0 0 10%;
			}
			@media screen and (min-width: 992px) and (max-width: 1199.99px) {
				flex: 0 0 35%;
			}

			.menu-item {
				position: relative;

				& > a, summary {
					@include flex(center, center, column);
					font-size: 13px;
					font-weight: 600;
					color: #8f8f8f;
					text-decoration: none;
					text-transform: uppercase;
					letter-spacing: 3px;
					transition: .2s;
					position: relative;

					&:hover {
						color: $Black;

						img {
							scale: 1.3;
						}
					}

					span {
						@include flex(center, center, column);

						.small {
							font-size: 10px;
						}
					}

					img {
						max-width: 35px;
						max-height: 35px;
						height: auto;
						object-fit: contain;
						transition: .4s ease;
					}
				}

				.dropdown {
					@include flex(center, center, column, $gap: 20px);
					@include position(100%, 50%);
					translate: -50%;
					padding: 20px;
					background-color: $White;
					max-width: unset;
					width: fit-content;
					white-space: nowrap;
					box-shadow: 0 3px 5px rgb(57 63 72 / 30%);
					z-index: 110;

					a {
						font-size: 13px;
						font-weight: 600;
						color: #8f8f8f;
						text-decoration: none;
						text-transform: uppercase;
						letter-spacing: 3px;
						transition: .2s;
						position: relative;

						&:hover {
							color: $Black;
						}
					}
				}

				@media screen and (max-width: 991.99px) {
					&.delivery, &.login {
						display: none;
					}
				}

				&.cart {
					align-self: center;

					svg {
						@include fixed-size(35px);
						object-fit: contain;

						path {
							fill: $Yellow;
						}
					}

					.badge span {
						letter-spacing: normal;
					}

					& > a {
						@include flex(center, flex-start);
					}
				}
			}
		}
	}

	nav.row {
		width: 100%;
		padding: 10px;
		@media screen and (max-width: 991.99px) {
			display: none;
		}

		ul {
			@include flex(center, initial);
			width: 100%;

			li {
				@include flex(center, center);
				flex: auto;
				padding: 0 10px;
				text-align: center;
				white-space: nowrap;
				position: relative;
				@media screen and (min-width: 992px) {
					max-width: 20%;
					border-right: solid 1px $Grey;
					white-space: initial;
				}

				&:last-child {
					border: none;
				}

				a, details {
					@include flex(center, center);
					height: 100%;
					text-decoration: none;
					color: $Black;
					font-weight: 600;
					letter-spacing: 2px;
					font-size: 15px;
					text-transform: uppercase;
					width: fit-content;
					@media screen and (min-width: 992px) {
						font-size: 14px;
					}

					&:not(:has(summary)) {
						position: relative;
					}

					&.active-link {
						color: $Brown;
						font-weight: bold;
					}

					&:hover {
						color: $Brown;
					}

					&:not(.active-link):before,
					&:not(.active-link):after,
					&.active-link:after {
						@include position($bottom: -5px, $left: 0, $right: 0);
						height: 2px;
						background-color: $Brown;
						user-select: auto;
						pointer-events: none;
					}

					&:not(.active-link):before {
						opacity: 0;
						transform: translateY(- $distance);
						transition: transform 0s $easeOutBack, opacity 0s;
					}

					&:not(.active-link):after {
						opacity: 0;
						transform: translateY(calc($distance / 2));
						transition: transform $duration $easeOutBack, opacity $duration;
					}

					&:not(.active-link):hover,
					&:focus {
						color: $Brown;

						&:before, &:after {
							opacity: 1;
							transform: translateY(0);
						}

						&:before {
							transition: transform $duration $easeOutBack, opacity $duration;
						}

						&:after {
							transition: transform 0s $duration $easeOutBack, opacity 0s $duration;
						}
					}

					&[open] {
						color: $Grey;
					}

					.nav-about {
						@include flex(flex-start, flex-start, column);
						@include position($top: calc(100% + 10px), $right: -10px);
						width: fit-content;
						max-width: unset;
						background-color: #fff;
						box-shadow: -3px 3px 6px rgba(0, 0, 0, 0.5);

						li {
							justify-content: start;
							text-align: left;
							max-width: 100%;
							width: 100%;
							border: none;
							padding: 0;
							border-top: solid 1px rgba(0, 0, 0, 0.25);

							a {
								padding: 10px;
								width: 100%;
								justify-content: start;
								text-align: left;
								white-space: nowrap;
								font-size: 12px;

								&:hover {
									color: $Black;
									opacity: .7;

									&::after, &::before {
										display: none;
									}
								}
							}
						}
					}
				}
			}
		}
	}
}

.line {
	width: 100%;
	height: 4px;
	display: flex;
	justify-content: space-between;

	.one {
		width: 33%;
		background-color: $Blue;
	}

	.two {
		width: 33%;
		background-color: $Black;
	}

	.three {
		width: 33%;
		background-color: $Brown;
	}
}

.inactive-link {
	color: $Grey;
	text-decoration: none;
	//font-weight: bold;
}

///SHOPPING CART///
.shopping-cart {
	@include position(30px, $right: -10px);
	width: 320px;
	max-width: unset;
	z-index: 900;
	background: white;
	display: block;
	border-radius: 3px;
	padding: 20px;
	overflow: hidden;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .26) !important;
	transition: all .2s ease;
	opacity: 0;
	transform-origin: right top 0;
	transform: scale(0);

	&.active {
		opacity: 1;
		transform-origin: right top 0;
		transform: scale(1);
	}

	&:after {
		@include position($bottom: 100%, $left: 89%);
		border-bottom: solid 8px $White;
		height: 0;
		width: 0;
		pointer-events: none;
		margin-left: -8px;
	}

	.shopping-cart-header {
		@include flex(space-between, flex-end, $gap: 10px);
		border-bottom: 1px solid #E8E8E8;
		padding-bottom: 10px;
		margin-bottom: 10px;

		.shopping-cart-total {
			color: $Blue;
			margin-left: auto;
			text-align: right;
			font-weight: 600;
			font-size: 18px;
		}

		.shopping-cart-count {
			@include flex(flex-start, flex-start);
		}
	}

	.shopping-cart-items {
		padding: 0;
		list-style: none;

		img {
			float: left;
			margin-right: 12px;
			max-width: 70px;
			max-height: 70px;
		}

		li {
			&:not(:last-child) {
				margin-bottom: 10px;
				padding-bottom: 10px;
				border-bottom: 1px solid #E8E8E8;
			}

			a {
				text-decoration: none;
				transition: .3s;

				&:hover {
					text-decoration: none;
					opacity: .65;
				}

				.item-title {
					@include flex(space-between, flex-start, $gap: 10px);
					font-size: 16px;
					font-weight: 600;

					.item-name {
						color: $Brown;
					}


					.item-quantity {
						color: $Blue;

						span {
							font-size: 14px;
							opacity: .5;
						}
					}
				}

				.item-detail {
					display: block;
					font-size: 12px;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					color: $Blue;
				}

				.item-price {
					color: $Blue;
					margin-left: auto;
					text-align: right;
					font-weight: 600;
				}

				.item-quantity {
					color: #ABB0BE;
				}
			}
		}
	}

	.button {
		padding: 12px;
		font-size: 16px;
		margin: 25px 0 15px 0;
	}
}

.badge {
	@include flex(center, center);
	background-color: $Blue;
	border-radius: 10px;
	color: $White;
	font-size: 12px;
	line-height: 1;
	padding: 3px 6px;
	text-align: center;
	vertical-align: middle;
	white-space: nowrap;
	width: fit-content;
	position: relative;
}
</style>